import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer
} from 'recharts';
import { formatDate } from '../../../exportreport/utils';

const formatter = (tickValue) => {
  if (!tickValue) return tickValue;
  return `${tickValue.toLocaleString()}`;
};

const CustomLineChart = ({ theme, data , isWeekly}) => {
 const roundToNiceNumber = (num) => {
   const niceNumbers = [1, 5, 10, 50, 100, 500, 1000, 5000, 10000]; // Add more if needed
   let magnitude = Math.pow(10, Math.floor(Math.log10(num)));
   let scaledNum = num / magnitude;
 
   // Find the closest nice number
   let closestNiceNumber = niceNumbers.reduce((prev, curr) => 
     Math.abs(curr - scaledNum) < Math.abs(prev - scaledNum) ? curr : prev
   );
 
   return closestNiceNumber * magnitude;
 };
 
 // Calculate the minimum and maximum values
 const minValue = Math.min(...data.map(d => d.val));
 const maxValue = Math.max(...data.map(d => d.val));
 
 // Calculate 20% below the min value and 20% above the max value
 const buffer = (maxValue - minValue) * 0.5;
 const adjustedMin = Math.floor(minValue - buffer); // Round down
 const adjustedMax = Math.ceil(maxValue);  // Round up
 
 // Round the adjusted min and max to nice numbers
 const roundedMin = roundToNiceNumber(adjustedMin);
 const roundedMax = roundToNiceNumber(adjustedMax);
 

  return (
    <ResponsiveContainer width="100%" height={428}>
      <LineChart data={data} margin={{ top: 20, right: 10, left: 10, bottom: 50 }}>
    

        <XAxis 
          dataKey="date" 
          tick={{ fill: theme === "dark" ? "#f8ffef" : 'rgb(102, 102, 102)',  fontWeight: 600 ,fontSize: 19 }} 
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : '#eee' }} 
          tickLine={false} 
          interval={0} 
          angle={-45} 
          textAnchor="end"
          padding={{ left: 20, right: 20 }}  
          height={50}
          tickFormatter={ (tick) => formatDate(tick,isWeekly )} 
        />
        <YAxis 
          tick={{ fill: theme === "dark" ? "#f8ffef" : 'rgb(102, 102, 102)',  fontWeight: 600,fontSize: 20, dx: 5 }} 
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : '#eee' }} 
          tickLine={false} 
          tickCount={8}
          domain={[roundedMin, roundedMax]}
          tickFormatter={formatter}
        />
        <Line 
          type="monotone" 
          dataKey="val" 
          className="line-chart-element"
          strokeWidth={4} 
          dot={false}
          strokeLinecap="butt"  
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CustomLineChart;
